"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "noventa-vicentina": {
    "4fb30369": [{
      "hkey": "77789c56",
      "slug": "are-crearo",
      "name": "Are-Crearo",
      "primary": true,
      "skipSearch": false
    }],
    "are": [{
      "hkey": "77789c56",
      "slug": "are-crearo",
      "name": "Are-Crearo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;